import { api } from '../../http';
import { PageRequest, PageResponse } from '../../types/interfaces';

import IApi from './interfaces/api';

class Api<T> implements IApi<T> {
  private readonly _baseUrl: string;
  protected readonly _abortController: AbortController;

  constructor(baseUrl: string, abortController: AbortController) {
    this._baseUrl = baseUrl;
    this._abortController = abortController;
  }

  async addOrUpdate(model: T): Promise<number | undefined> {
    const apiCallResult = await api.post(this._baseUrl, model, {
      signal: this._abortController.signal,
      validateStatus: () => true
    });
    if (apiCallResult.status === 400 && apiCallResult.data === 'SameName') {
      console.error('Ошибка 400: samename');
      return -1;
    }

    if (typeof apiCallResult.data === 'number' && apiCallResult.data !== 0) {
      return apiCallResult.data;
    }

    return undefined;
  }

  async get(id: number) {
    const apiCallResult = await api.get<T>(this._baseUrl + `${id}`, {
      signal: this._abortController.signal
    });
    return apiCallResult?.data ?? undefined;
  }

  async getAll(pageRequest: PageRequest) {
    const searchParams = new URLSearchParams();
    Object.keys(pageRequest).forEach((key) => {
      if (pageRequest[key]) {
        searchParams.append(key, pageRequest[key]!.toString());
      }
    });
    const apiCallResult = await api.get<PageResponse<T>>(
      this._baseUrl + '?' + new URLSearchParams(searchParams),
      { signal: this._abortController.signal }
    );
    return apiCallResult?.data ?? undefined;
  }

  async delete(id: number) {
    await api.delete(this._baseUrl + `${id}`, {
      signal: this._abortController.signal
    });
  }
}

export default Api;
